export default function() {
  // Show an 'x' in the cart count when in the theme editor and viewing the header section
  $(document).on('shopify:section:load, shopify:section:select', (e) => {
    if (e.detail.sectionId !== 'INF-Header') { return; }

    const $cart_count = $('[data-cart-count]');
    if ($cart_count.eq(0).text() !== '0' && $cart_count.eq(0).text() !== 'x') { return; }

    $cart_count.text('x').attr('data-cart-count', 'x');
  });

  // Remove 'x' in the cart count when leaving header section
  $(document).on('shopify:section:deselect', (e) => {
    if (e.detail.sectionId !== 'INF-Header') { return; }

    const $cart_count = $('[data-cart-count]');
    if ($cart_count.eq(0).text() !== 'x') { return; }

    $cart_count.text('0').attr('data-cart-count', '0');
  });
}